import { NavBar } from '../../components/navBar.tsx';
import { PageTitle } from '../../components/pageTitle.tsx';
import { Diagnostics } from './diagnostics.tsx';
import { ReleaseNotes } from './releaseNotes.tsx';


export function Index() {

    return (
        <>
            <PageTitle title='BG Web Apps' />
            <NavBar />
            <div
                className='content'
                style={{ marginTop: '30px', marginLeft: '40px', marginRight: '40px' }}
            >
                <Diagnostics />
                <ReleaseNotes />
            </div>
        </>
    );
}
